$(document).ready(function () {
  let cropper;
  const image = document.getElementById("mode-image");
  const croppedResult = document.querySelector(".picker-set-img");
  $(".picker-input").on("change", function (event) {
    const file = event.target.files[0];
    console.log( file );
    if (file) {
      const reader = new FileReader();
      console.log( reader );
      reader.onload = function (e) {
        image.src = e.target.result;
        $(".image-edit-model").addClass("open");
        if (cropper) cropper.destroy();
        cropper = new Cropper(image, {
          autoCropArea: 0.5,
          viewMode: 1,
          rotatable: true,
        });
      };
      reader.readAsDataURL(file);
    }
  });
  $("#rotate-btn").on("click", function () {
    if (cropper) {
      cropper.rotate(90);
    }
  });

  $("body").on('change',"#custom_preview", function() {
    //$(".product-form__submit").addClass('productAddToCart');  
    $(".product-form__submit").prop('disabled', true);
  });
 function checkFrameUrl(){
   var generatImg = $('#cropped-image-url').val();
   console.log('generatImg', generatImg);
    if (generatImg != "") {      
      $('product-form.product-form').find("form").submit();
    } else {
      setTimeout(checkFrameUrl, 500);
    }
 }
  $("body").on('click','.productAddToCart', function(e) {
    e.preventDefault();
    $(this).addClass("add_loader");
    $(".product-form__submit").prop('disabled', true);
    checkFrameUrl();
  });
  
  const unsignedUploadPreset = 'doc_codepen_example';
  async function render(file) {
    // Cloudinary upload URL
    const url = 'https://api.cloudinary.com/v1_1/demo/upload';
    const unsignedUploadPreset = 'doc_codepen_example';
    const tags = 'browser_upload';
    
    // Create URL parameters for the POST request
    const params = new URLSearchParams();
    params.append('upload_preset', unsignedUploadPreset);
    params.append('tags', tags);
    params.append('file', file);
    // Fetch without FormData (Note: no file here)
    fetch(url, {
      method: 'POST',
      body: params
    })
      .then(response => response.json())
      .then(data => {
        $("#cropped-image-url").val(data.url);
        $(".picker-input").val("");
        $(".product-form__submit").prop('disabled', false);
        $("#cropped-image-url").prop('disabled', false);
      })
      .catch(error => console.error('Error:', error));
  }  
  
  $("#done-btn").on("click", function () {
    const canvas = cropper.getCroppedCanvas();
    if (canvas) {
      croppedResult.innerHTML = `<div class="picker-set-close">
                          <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 16 16"><path fill="currentColor" d="m3.5 2.086l4.5 4.5l4.5-4.5L13.914 3.5L9.414 8l4.5 4.5l-1.414 1.414l-4.5-4.5l-4.5 4.5L2.086 12.5l4.5-4.5l-4.5-4.5z"/></svg>
                        </div><img src="${canvas.toDataURL(
                          "image/png"
                        )}" alt="Cropped Image">`;
    }
    $(".image-edit-model").removeClass("open");
    let canvasImg = canvas.toDataURL("image/png");
    render(canvasImg);
    
    //$(".picker-input").val(`${canvas.toDataURL("image/png")}`);
    cropper.destroy();
  });
  $("#close-modal").on("click", function () {
    $(".image-edit-model").removeClass("open");
    if (cropper) cropper.destroy();
    $(".picker-input").val("");
    $("#cropped-image-url").val("");
    $(".product-form__submit").removeClass("productAddToCart");
    croppedResult.innerHTML = "";
  });
  $("body").on("click", ".picker-set-close", function () {
    if (cropper) cropper.destroy();
    $(".picker-input").val("");
    $(".product-form__submit").removeClass("productAddToCart");
    $("#cropped-image-url").val("");
    $("#cropped-image-url").prop('disabled', true);
    croppedResult.innerHTML = "";
  });
});
